import React, { Component, useState, useEffect, createContext } from 'react';
import Toolbar from "components/Content/Toolbar/toolbar"
import { fabric } from 'fabric';
import ObjectToolBar from "../../components/Content/ObjectToolBar";
import 'containers/Content/CreationHome.css';
import DraftConfirmationModal from '../../components/Content/DraftConfirmationModal';
import CompleteAndPostConfirmationModal from '../../components/Content/CompleteAndPostConfirmationModal';
import AxiosConfig from "axiosConfig";
import 'fabric-history';

export const CreationContext = createContext({
    creationCanvas: ' ',
    setCreationCanvas: () => { },
    backgroundFill: ' ',
    setBackgroundFill: () => { }
});

export function renderCanvas() {
    let canvas = document.getElementById("CreationCanvas");
    canvas.renderAll();
}


export const CreationSuite = (props) => {
    const [creationCanvas, setCreationCanvas] = useState(' ');
    const [backgroundFill, setBackgroundFill] = useState("white");
    const [showDraftModal, setShowDraftModal] = useState(false);
    const [showCompleteAndPostModal, setShowCompleteAndPostModal] = useState(false);

    useEffect(() => {
        setCreationCanvas(new fabric.Canvas("CreationCanvas", {
            backgroundColor: "white",
            width: 957,
            height: 600
        }));
        fabric.IText.prototype.initHiddenTextarea = (function (initHiddenTextarea) {
            return function () {
                var result = initHiddenTextarea.apply(this);
                fabric.document.body.removeChild(this.hiddenTextarea);
                this.canvas.wrapperEl.appendChild(this.hiddenTextarea);
                return result;
            };
        })(fabric.IText.prototype.initHiddenTextarea);
    }, [])

    const dataURItoBlob = (dataURI) => {
        let byteString = atob(dataURI.split(',')[1]);
        let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

        let ab = new ArrayBuffer(byteString.length);

        let ia = new Uint8Array(ab);

        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        let blob = new Blob([ab], { type: mimeString });
        return blob;
    }

    const saveCanvasAsDraft = () => {
        if (creationCanvas._objects.length > 0) {
            creationCanvas.discardActiveObject().renderAll();
            console.log(creationCanvas);
            let data = new FormData();
            let pngBase64Data = creationCanvas.toDataURL("image/png");
            console.log(pngBase64Data);
            let pngBlob = dataURItoBlob(pngBase64Data);
            console.log(pngBlob);
            console.log("Stringify canvas")
            let canvasJSON = JSON.stringify(creationCanvas)
            data.append("canvas_data", pngBlob);
            data.append("canvas_JSON", canvasJSON)
            data.append("user", '');
            AxiosConfig.post('creation_suite/saved_canvas/', data, {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }).then(res => console.log(res))
                .catch(err => console.log(err.response)
                );
        }
    }

    const saveToAlbum = () => {
        console.log("Inside save to album");
        if (creationCanvas._objects.length > 0) {
            creationCanvas.discardActiveObject().renderAll();
            let data = new FormData();
            let pngBase64Data = creationCanvas.toDataURL("image/png");
            console.log(pngBase64Data);
            let pngBlob = dataURItoBlob(pngBase64Data);
            console.log(pngBlob);
            const file = new File([pngBlob], 'test.png', { type: "image/png" });
            data.append("media", file);
            data.append("username", '');
            data.append("file_type", 'png');
            data.append("media_type", 'I');
            data.append("user_access", 'P');
            data.append("media_source", 'E');
            data.append("belongs_in", 'A');
            props.handleCreationSuiteUpload(file);
            props.onClose();
            // AxiosConfig.post('mediaManager/media/', data, {
            //     headers: {
            //         'content-type': 'multipart/form-data'
            //     }
            // }).then(res => { })
            //     .catch(err => console.log(err.response)
            //     );
        }
    }

    const toggleDraftModal = () => {
        setShowDraftModal(!showDraftModal);
    }

    const toggleCompleteAndPostModal = () => {
        setShowCompleteAndPostModal(!showCompleteAndPostModal);
    }

    return (
        <CreationContext.Provider value={{ value: [creationCanvas, setCreationCanvas], value2: [backgroundFill, setBackgroundFill] }}>
            <div className='canvas-objects' >
                <ObjectToolBar />
                <canvas className="canvas"
                    id="CreationCanvas" />
                <Toolbar fileData={props.fileData} />
            </div>
            <div className='canvas-buttons'>
                <button className="save-draft-button" onClick={toggleDraftModal}>Save as Draft</button>
                <button className="save-to-album-button" onClick={toggleCompleteAndPostModal}>Complete & Post</button>
            </div>
            <DraftConfirmationModal show={showDraftModal} handleClose={toggleDraftModal} handleSave={saveCanvasAsDraft}>
                <p>Are you sure you want to save this file?</p>
            </DraftConfirmationModal>
            <CompleteAndPostConfirmationModal show={showCompleteAndPostModal} handleClose={toggleCompleteAndPostModal} handleSave={saveToAlbum}>
                <p>Are you sure you want to save this file?</p>
            </CompleteAndPostConfirmationModal>
        </CreationContext.Provider>
    )
}

export default CreationSuite;